import { ApiResponse } from '../../types/ApiResponse.types';
import { CinemaRoomDto } from '../cinema-room/CinemaRoomDto.types';
import { SeatCategoryDto } from '../seat-category/SeatCategoryDto.types';
import { SeatPositionDto } from '../seat-position/SeatPositionDto.types';
import { ShapeDto } from '../shape/ShapeDto.types';
import { TransformDto } from '../transform/TransformDto.types';

export enum SeatType {
    SEAT = 'seat',
    LOVESEAT_LEFT = 'loveseat_left',
    LOVESEAT_RIGHT = 'loveseat_right',
    DISABLED = 'disabled',
    WHEELCHAIR = 'wheelchair',
    /** @deprecated be careful to use it, on the backend it's not implemented yet   */
    D_BOX = 'd_box'
}

export type SeatDto = {
    id: number;
    cinemaRoomId: CinemaRoomDto['id'];
    seatShapeId: ShapeDto['id'];
    seatTransformId: TransformDto['id'];
    type: SeatType;
} & ApiResponse<
    unknown,
    {
        cinemaRoom?: CinemaRoomDto;
        seatShape?: ShapeDto;
        seatTransform?: TransformDto;
        seatPosition?: SeatPositionDto;
        seatCategory?: SeatCategoryDto;
    }
>;
